import type { InvitationType } from '../../types/guestShare';

import { slice } from '../slices/guestShare';

const nameSpace = slice.name;

export const isLoading = (state: RootState): boolean => state[nameSpace].isLoading;
export const totalCount = (state: RootState): number => state[nameSpace].totalCount;
export const page = (state: RootState): number => state[nameSpace].page;
export const invitationList = (state: RootState): InvitationType[] => state[nameSpace].invitationList;
